// extracted by mini-css-extract-plugin
export default {"form":"MakeForm_form__21fZV","title":"MakeForm_title__0VYl+","input":"MakeForm_input__fCsWE","createBtn":"MakeForm_createBtn__m7lUa","closeBtn":"MakeForm_closeBtn__96zMv"};